module.exports = __webpack_public_path__ + "img/logo_blanco.2003aa00.png";